import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../../assets/images/logo.svg'
import userIcon from '../../assets/images/user-icon-tp.svg'
import { useAuth } from '../../contexts/authcontext'
import { useCart } from '../../contexts/cartcontext'

const Header = ({ hideMenu }) => {
  const [isMenuVisible, setIsMenuVisible] = useState(false)
  const [isSticky, setIsSticky] = useState(false)
  const { token, user, logOut } = useAuth()
  const { state } = useCart()
  const navigate = useNavigate()
  const totalItems =
    state?.items?.reduce((total, item) => total + item.quantity, 0) || 0

  const scrollToHowItWorks = () => {
    navigate('/', { state: { scrollToHowItWorks: true } })
  }

  const buyVoucher = () => {
    // Guest users can now access buy voucher page
    navigate('/buy-a-voucher')
  }

  const authUserHeader = [
    { name: 'MY DASHBOARD', link: '/dashboard' },
    { name: 'START NEW BOOK', link: '/bump-to-birthday-book' }
  ]
  const unAuthHeader = [
    { name: 'How it works', onClick: scrollToHowItWorks },
    { name: 'Books & Pricing', link: '/bump-to-birthday-book' },
    { name: 'Gifting', onClick: buyVoucher },
    { name: 'About', link: '/about' },
    { name: 'Blog', link: 'blogs' }
  ]

  const handleLogout = () => {
    logOut()
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 0) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible)
  }

  const closeMenu = () => {
    setIsMenuVisible(false)
  }

  return (
    <header
      className={`header homepage-header brd-btm ${isSticky ? 'sticky' : ''}`}
    >
      <div className='container'>
        <div className='d-flex align-items-center justify-content-justify w-100'>
          <div className='logo'>
            <Link to='/'>
              <img src={logo} alt='logo' />
            </Link>
          </div>
          {!hideMenu && (
            <>
              <div className='deviceMenuClick' onClick={toggleMenu}></div>

              <nav
                className={`topmenu ms-auto me-0 ${
                  isMenuVisible ? 'visible' : ''
                }`}
              >
                <div className='deviceMenuClose' onClick={toggleMenu}></div>
                <ul>
                  {token !== ''
                    ? authUserHeader.map(navLink => (
                        <li key={navLink.name}>
                          <Link to={navLink.link} onClick={closeMenu}>
                            {navLink.name}
                          </Link>
                        </li>
                      ))
                    : unAuthHeader.map(navLink => (
                        <li key={navLink.name}>
                          {navLink.onClick ? (
                            <a
                              onClick={() => {
                                navLink.onClick()
                                closeMenu()
                              }}
                              className='nav-button'
                            >
                              {navLink.name}
                            </a>
                          ) : (
                            <Link to={navLink.link} onClick={closeMenu}>
                              {navLink.name}
                            </Link>
                          )}
                        </li>
                      ))}
                </ul>
              </nav>
              {token !== '' ? (
                <div className='headerRight'>
                  <div className='userheadersection'>
                    <Link
                      to='#'
                      className='userlink dropdown-toggle'
                      data-bs-toggle='dropdown'
                    >
                      <img src={userIcon} alt='user icon' />{' '}
                      <span>{user?.firstName}</span>
                    </Link>
                    <ul className='dropdown-menu'>
                      <li>
                        <Link className='dropdown-item' to='/dashboard'>
                          GO TO MY DASHBOARD
                        </Link>
                      </li>
                      <li>
                        <Link className='dropdown-item' to='/manage-account'>
                          MANAGE ACCOUNT
                        </Link>
                      </li>
                      <li>
                        <Link
                          className='dropdown-item'
                          to='/manage-payment-methods'
                        >
                          MANAGE PAYMENT METHODS
                        </Link>
                      </li>
                      <li>
                        <Link className='dropdown-item' to='/order-history'>
                          PAYMENT HISTORY
                        </Link>
                      </li>
                      <li>
                        <Link
                          className='dropdown-item'
                          to='/print-order-details'
                        >
                          PRINT ORDER DETAILS
                        </Link>
                      </li>
                      <li>
                        <Link
                          className='dropdown-item'
                          to='/bump-to-birthday-book'
                        >
                          START A NEW BOOK
                        </Link>
                      </li>
                      <li>
                        <Link className='dropdown-item' to='/buy-a-voucher'>
                          BUY A VOUCHER
                        </Link>
                      </li>
                      <li>
                        <Link className='dropdown-item' to='/contact-us'>
                          CONTACT US
                        </Link>
                      </li>
                      <li>
                        <Link className='dropdown-item' to='/faq'>
                          FAQS
                        </Link>
                      </li>
                      <li>
                        <Link
                          className='dropdown-item'
                          to='#'
                          onClick={handleLogout}
                        >
                          LOG OUT
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className='cartheadersection ms-3'>
                    <Link to='/cart' className='headeractions cartLink'></Link>
                    {totalItems > 0 && (
                      <div className='card-item-cnt'>{totalItems}</div>
                    )}
                  </div>
                </div>
              ) : (
                <div className='headerRight'>
                  <div className='cartheadersection'>
                    <Link to='/cart' className='headeractions cartLink'></Link>
                    {totalItems > 0 && (
                      <div className='card-item-cnt'>{totalItems}</div>
                    )}
                  </div>
                  <div className='userheadersection ms-4'>
                    <Link
                      to='#'
                      className='userlink dropdown-toggle'
                      data-bs-toggle='dropdown'
                    >
                      <img src={userIcon} alt='user icon' />
                    </Link>
                    <ul className='dropdown-menu'>
                      <li>
                        <Link className='dropdown-item' to='/login'>
                          LOG IN
                        </Link>
                      </li>
                      <li>
                        <Link className='dropdown-item' to='/signup'>
                          CREATE A NEW ACCOUNT
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
